<button
  type="button"
  class="flex items-center gap-md py-sm w-full border-b border-neutral-200 last:border-0"
  (click)="selectSubMenuItem(subItem())">
  @if (subItem().showImage) {
    <lib-avatar
      [fullName]="subItem().mainText | transloco"
      [img]="subItem().img?.url || ''"
      [imgClass]="'size-8! rounded-full'" />
  }

  <div class="flex flex-col me-auto items-start">
    <span
      class="font-semibold text-sm"
      [class]="
        (subItem().isSelected ? 'text-primary-600' : 'text-neutral-900') +
        ' ' +
        (subItem().isMainTextTranslatable ? '' : 'uppercase') +
        ' ' +
        (subItem().itemClass || '')
      ">
      @if (subItem().isMainTextTranslatable) {
        {{ subItem().mainText | transloco }}
      } @else {
        {{ subItem().mainText }}
      }
    </span>
  </div>

  @if (subItem().isSelected) {
    <lib-check-icon iconClass="size-4 text-primary-600 do-not-transform" />
  }
</button>
